import React from "react";
import Icon from "../../../components/AppIcon";

const LocationMap = () => {
  return (
    <div className="relative w-full max-w-7xl mx-auto px-6 py-12">
      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="flex items-center justify-center gap-2 text-3xl md:text-4xl font-bold text-text-primary">
          <span className="flex items-center justify-center w-10 h-10 rounded-full border-2 border-red-500">
            <Icon name="MapPin" size={20} className="text-red-500" />
          </span>
          Find Us on the Map
        </h2>
        <p className="text-text-secondary mt-2">
          Visit our headquarters or get directions instantly
        </p>
      </div>

      {/* Map Container */}
      <div className="relative w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl border border-border">
        {/* Google Map iframe */}
        <iframe
          title="Company Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3602.711974419067!2d81.83193397412718!3d25.447891221503372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399acac55c387b57%3A0x623032cee1c4ab39!2sKharbanda%20Motors!5e0!3m2!1sen!2sin!4v1759136681973!5m2!1sen!2sin"
          className="w-full h-full grayscale hover:grayscale-0 transition-all duration-500"
          allowFullScreen=""
          loading="lazy"
        ></iframe>

        {/* Overlay card */}
        <div className="absolute bottom-6 left-6 bg-white rounded-xl shadow-xl p-6 max-w-sm border border-border">
          <h3 className="text-lg font-semibold text-text-primary mb-2 flex items-center space-x-2">
            Conatact Us
          </h3>

          <div className="space-y-2 text-sm">
            <p className="flex items-center space-x-2">
              <Icon name="Phone" size={16} className="text-accent" />
              <span>+91 98765 43210</span>
            </p>
            <p className="flex items-center space-x-2">
              <Icon name="Mail" size={16} className="text-accent" />
              <span>contact@kharbandamotors.com</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationMap;
